export type Direction = 'asc' | 'desc';

export type Comparable =
  | boolean
  | number
  | string
  | Date
  | ComparableArray
  | null
  | undefined;

export type ComparableArray = Array<Comparable>;

const collator = new Intl.Collator(undefined, { sensitivity: 'case' });

export function sort<T>(
  data: T[],
  key: (value: T) => Comparable,
  direction: Direction,
): T[] {
  const indexes = data.map((_, i) => i);
  const keys = data.map(key);
  indexes.sort((a, b) => {
    return (function compare(a, b): number {
      if (a instanceof Array && b instanceof Array) {
        for (let i = 0; i < a.length; i++) {
          const result = compare(a[i], b[i]);
          if (result) {
            return result;
          }
        }
        return 0;
      }
      if (typeof a === 'string' && typeof b === 'string') {
        return collator.compare(a, b);
      }
      if (a != null && b == null) {
        return 1;
      }
      if (a == null && b != null) {
        return -1;
      }
      return a! < b! ? -1 : b! < a! ? 1 : 0;
    })(keys[a], keys[b]);
  });
  if (direction === 'desc') {
    indexes.reverse();
  }
  return indexes.map(i => data[i]);
}
